module.exports = __webpack_public_path__ + "static/media/diaper_img.87c3b7c0.png";